import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import './styles.scss'


const ContactFrom = () => {
    const [success, setsuccess] = useState(false)
    function sendEmail(e) {
        e.preventDefault();
        emailjs.sendForm('service_geak525', 'sendreply_tts000', e.target, 'user_ORZrOthuxWcnlzmGhCJTQ')
            .then((result) => {
                console.log(result.text);
                setsuccess(true)
            }, (error) => {
                console.log(error.text);
                alert(error.text)
            });
        e.target.reset()
    }
    return (
        <div className="formSubmit">
            <form onSubmit={e => sendEmail(e)}>
                <input type="hidden" name="user_subject" value="Techseminal- website" />
                <label style={{ marginTop: '0px' }}>Name</label>
                <input type="text" name="user_name" placeholder="Your full name"/>
                <label>Email</label>
                <input type="email" name="user_email" placeholder="your email address"/>
                <label>Message</label>
                <textarea name="user_message" placeholder="your message..."/>
                <br />
                <input style={{ background: '#fff', color: '#4285f4' }} type="submit" value='send' />
            </form>
            {success ?
                <p>Email sent successfully</p> : ''
            }
        </div>
    );
}

export default ContactFrom;